/**
 * Отметка «человек только что вернулся с оплаты».
 *
 * Ставится на странице входа с юбилейного лендинга, читается главным экраном:
 * по ней он один раз показывает окно с итогом покупки. Держим в sessionStorage,
 * а не в localStorage: окно должно всплыть один раз за возвращение, а не
 * встречать человека каждый раз, пока он не почистит браузер.
 */
const KEY = "fw_purchase_return";

export const markPurchaseReturn = () => {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch (e) {
    // Приватный режим Safari запрещает запись — окно просто не всплывёт.
    // Терять из-за этого вход было бы куда хуже.
  }
};

/** Читает отметку и сразу снимает её: окно показывается один раз. */
export const takePurchaseReturn = () => {
  try {
    const had = sessionStorage.getItem(KEY) === "1";
    sessionStorage.removeItem(KEY);

    return had;
  } catch (e) {
    return false;
  }
};
